import React from 'react'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'

const Terms: React.FC = () => {
  const { t } = useTranslation()

  const sections = [
    { titleKey: 'termsSection1Title', contentKey: 'termsSection1Content' },
    { titleKey: 'termsSection2Title', contentKey: 'termsSection2Content' },
    { titleKey: 'termsSection3Title', contentKey: 'termsSection3Content' },
    { titleKey: 'termsSection4Title', contentKey: 'termsSection4Content' },
    { titleKey: 'termsSection5Title', contentKey: 'termsSection5Content' },
    { titleKey: 'termsSection6Title', contentKey: 'termsSection6Content' },
    { titleKey: 'termsSection7Title', contentKey: 'termsSection7Content' }
  ]

  return (
    <div className="max-w-4xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-3xl md:text-4xl font-bold text-apple-gray-900 mb-6">
          {t('termsTitle')}
        </h1>
        
        <p className="text-apple-gray-500 text-sm mb-8">
          {t('termsLastUpdated')}
        </p>

        <div className="prose prose-lg max-w-none">
          <p className="text-apple-gray-600 text-lg leading-relaxed mb-8">
            {t('termsIntro')}
          </p>

          {sections.map((section, index) => (
            <motion.div
              key={section.titleKey}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.05 }}
              className="mb-8"
            >
              <h2 className="text-xl font-semibold text-apple-gray-900 mb-4">
                {t(section.titleKey)}
              </h2>
              <p className="text-apple-gray-600 leading-relaxed whitespace-pre-line">
                {t(section.contentKey)}
              </p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  )
}

export default Terms




